// extracted by mini-css-extract-plugin
export default {"schoolLogoWrapper":"SchoolLogo_schoolLogoWrapper__n-8cn","buttonsWrapper":"SchoolLogo_buttonsWrapper__-I3t8","logoWrapper":"SchoolLogo_logoWrapper__MmQmN"};